'use strict';

import share from './src/share';
export default share;